<template>
	<div v-on="$listeners" class="research-row">
		<div class="research-title"><SvgIcons name="touguandiaoyan" class="research-icon" />{{ item.title }}</div>
		<div class="research-bottom">
			<p>{{ formatStockName }}</p>
			<p>{{ dateFormatYearMonthDate(item.ptime) }}</p>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { dateFormatYearMonthDate } from '@/utils/format';

const props = defineProps({
	item: {
		type: Object,
		required: true
	}
});

const toCode = code => {
	if (!code) return;
	let letters = code.match(/[A-Za-z]+/g)[0];
	let numbers = code.match(/[0-9]+/g)[0];
	return numbers + '.' + letters.toUpperCase();
};
const formatStockName = computed(() => {
	return `${props.item.stockName} ${toCode(props.item.fullCode)}`;
});
</script>

<style scoped lang="less">
.research-row {
	margin: 0 16px;
	padding: 12px 0;

	& + .research-row {
		border-top: 1px solid #f2f3f5;
	}
	&:first-child {
		padding-top: 4px;
	}

	.research-title {
		color: #222;
		font-size: 16px;
		font-weight: 500;
		line-height: 24px; /* 150% */

		.research-icon {
			float: left;
			width: 20px;
			height: 20px;
			margin-top: 2px;
			margin-right: 4px;
		}
	}
	.research-bottom {
		display: flex;
		justify-content: space-between;
		margin-top: 8px;
		color: #8e8d8c;
		font-size: 13px;
		font-weight: 400;
		line-height: normal;
	}
}
</style>
